import { z } from 'zod';
import { FlowKind } from '../flow/enums.js';
/** How a clone of a flow treats the subflows it references. */
export var FlowSubflowCloningStrategy;
(function (FlowSubflowCloningStrategy) {
    FlowSubflowCloningStrategy["CloneDeep"] = "CloneDeep";
    FlowSubflowCloningStrategy["ShallowReferenceByIds"] = "ShallowReferenceByIds";
})(FlowSubflowCloningStrategy || (FlowSubflowCloningStrategy = {}));
export const FlowSubflowCloningStrategyByFlowKindSchema = z.object(Object.fromEntries(Object.values(FlowKind).map((kind) => [kind, z.enum(FlowSubflowCloningStrategy)])));
export function getDefaultFlowSubflowCloningStrategyByFlowKind() {
    return {
        [FlowKind.Base]: FlowSubflowCloningStrategy.CloneDeep,
        [FlowKind.FlowTemplate]: FlowSubflowCloningStrategy.CloneDeep,
        [FlowKind.Skill]: FlowSubflowCloningStrategy.ShallowReferenceByIds,
    };
}
//# sourceMappingURL=subflowCloningStrategy.js.map